import { usePageContext } from "vike-react/usePageContext"
import Localization from "aldoo-ra/Localization"
import { useMemo } from "react"

export function Link({ to, className, children, ...props }) {
  const pageContext = usePageContext()
  const { currentLanguage } = Localization()

  // Process the URL to include language code
  const href = useMemo(() => {
    let url = to

    // Handle query string URLs
    if (to.startsWith('?')) {
      url = pageContext.urlPathname + to
    }

    // Only process relative URLs (internal links)
    if (url.startsWith('/') && !url.startsWith('//')) {
      // Check if URL already has language code
      const hasLangCode = url.match(/^\/([a-z]{2})(\/|$)/)

      if (!hasLangCode && currentLanguage && currentLanguage !== 'en') {
        // Prepend language code for non-English languages
        url = `/${currentLanguage}${url}`
      }
    }

    return url
  }, [to, currentLanguage, pageContext.urlPathname])

  return (
    <a href={href} className={className} {...props}>
      {children}
    </a>
  )
}
